import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const LABELS = { accepted: 'Accepted · awaiting receipt', sent: 'Sent · awaiting receipt', queued: 'Queued', sending: 'Sending', delivery_delayed: 'Delivery delayed', delivered: 'Delivered', failed: 'Failed', bounced: 'Bounced', undelivered: 'Undelivered', canceled: 'Canceled' };

export const SupportDeliveryStatus = ({ sessionId }) => {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const response = await fetch(`${API}/api/support-chat/admin/sessions/${encodeURIComponent(sessionId)}/deliveries`, { credentials: 'include' });
        if (response.ok && active) setRows(await response.json());
      } catch { /* Refresh provides an explicit error if the network is unavailable. */ }
    };
    load();
    const timer = setInterval(load, 15000);
    return () => { active = false; clearInterval(timer); };
  }, [sessionId]);
  const refresh = async () => {
    setBusy(true); setError('');
    try {
      const response = await fetch(`${API}/api/support-chat/admin/sessions/${encodeURIComponent(sessionId)}/deliveries/refresh`, { method: 'POST', credentials: 'include' });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || 'Delivery status unavailable.');
      setRows(data.deliveries || []);
      if (data.errors?.length) setError('Some provider receipts are not available yet.');
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  if (!rows.length) return null;
  return <section className="mb-3 border-b border-zinc-700 pb-3" data-testid="support-delivery-status">
    <div className="flex items-center justify-between gap-2 mb-2">
      <h3 className="text-xs font-bold text-zinc-200" data-testid="support-delivery-heading">Delivery receipts</h3>
      <button type="button" onClick={refresh} disabled={busy} className="text-zinc-300 hover:text-white disabled:opacity-40" title="Refresh provider receipts" aria-label="Refresh provider receipts" data-testid="support-delivery-refresh"><RefreshCw size={14} className={busy ? 'animate-spin' : ''} /></button>
    </div>
    <ul className="space-y-1">
      {rows.map((row, i) => <li key={`${row.id}-${i}`} className="flex flex-wrap items-center justify-between gap-x-2 text-[11px] text-zinc-300" data-testid={`support-delivery-row-${i}`}>
        <span>{row.channel === 'sms' ? 'SMS' : 'Email'} · {row.destination}</span>
        <span className={row.status === 'delivered' ? 'text-emerald-400' : ['failed', 'undelivered', 'bounced'].includes(row.status) ? 'text-red-300' : 'text-amber-300'} data-testid={`support-delivery-result-${i}`}>{LABELS[row.status] || row.status}</span>
      </li>)}
    </ul>
    {error && <p role="alert" className="mt-2 text-xs text-red-300" data-testid="support-delivery-error">{error}</p>}
  </section>;
};